import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { ApiPaths } from "../../api/paths";
import useData from "../../hooks/use-data";
import { DashboardStatisticsType } from "../../types/dashboard";
import DashboardStats from "./DashboardStats/DashboardStats";
import "./dashboard.css";
import { useAppContext } from "../../context/app-context";

export default function Dashboard() {
  const { t } = useTranslation(["dashboard", "components"]);
  const { keycloakProfile } = useAppContext();
  const { data, loading } = useData<DashboardStatisticsType>(
    `${ApiPaths.dashboard}?search=${keycloakProfile?.email}`,
    {
      onError: (err) => {
        toast(err.response?.data?.message || "An error occurred", {
          type: "error",
        });
      },
      fetchIf: !!keycloakProfile?.email,
    }
  );

  return (
    <div className="p-3 pb-5 p-lg-4">
      <div className="row">
        <h1 className="primary-title dashboard-title mb-3 mb-lg-2">
          {t("heading", { ns: "dashboard" })}
        </h1>

        <div className="col pe-md-4">
          <div className="px-2">
            <div className="row bg-white box-shadow rounded py-4 py-md-3 mb-4">
              <div className="col-12 col-md-6 d-flex flex-column align-items-center p-3 covers-container mb-4 mb-md-0">
                <h4 className="covers-title">
                  {t("stats.expired_covers", { ns: "dashboard" })}
                </h4>
                <p className="covers-count mb-3">
                  {(data && data?.coverDetails?.expiredCovers) ?? "-"}
                </p>

                <Link
                  className="primary-button renew-button"
                  to={`/my-covers?status=expired`}
                >
                  {t("button.renew", { ns: "dashboard" })}
                </Link>
              </div>
              <div className="col-12 col-md-6 d-flex flex-column align-items-center p-3 covers-container">
                <h4 className="covers-title">
                  {t("stats.cover_renewals", { ns: "dashboard" })}
                </h4>
                <p className="covers-count mb-3">
                  {(data && data?.coverDetails?.coverdRenewal) ?? "-"}
                </p>
                <Link
                  className="primary-button renew-button background-success"
                  to={`/my-covers?status=pending`}
                >
                  {t("button.renew", { ns: "dashboard" })}
                </Link>
              </div>
            </div>
          </div>
          <div className="row mb-4 time-chart-cont p-2">
            <div className="bg-white box-shadow rounded-2 py-3">
              <div className="bg-white px-3 pt-4 p-lg-0 mb-3 rounded-2 dashboard-stats">
                <DashboardStats stats={data} loading={loading} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
